import type { Player } from '../api/types';

export interface AdminMessage {
  messages?: string[];
  text?: string;
  type?: 'fail' | 'success';
  short?: string;
}

export interface AdminState {
  users: Player[];
  message: AdminMessage;
}

export interface AdminAction {
  type: string;
  [key: string]: unknown;
}

export const initialState = (): AdminState => ({ users: [], message: {} });

export default function admin(
  state: AdminState = initialState(),
  action?: AdminAction
): AdminState {
  if (!action) {
    return state;
  }
  switch (action.type) {
    case 'ADMIN_USERS_GET_ALL_USERS_SUCCESS':
      return { ...state, users: action.users as Player[] };
    case 'ADMIN_USERS_ACTIVATE_FAIL':
    case 'ADMIN_USERS_ACTIVATE_SUCCESS':
    case 'ADMIN_USERS_DEACTIVATE_FAIL':
    case 'ADMIN_USERS_DEACTIVATE_SUCCESS':
    case 'ADMIN_USERS_UNSET_ADMIN_SUCCESS':
    case 'ADMIN_USERS_UNSET_ADMIN_FAIL':
    case 'ADMIN_USERS_SET_ADMIN_FAIL':
    case 'ADMIN_USERS_SET_ADMIN_SUCCESS':
      if (typeof action.message !== 'object') {
        throw new Error('Expected message to be an object.');
      }
      return { ...state, message: action.message as AdminMessage };
    case 'ADMIN_POINTS_SEND_EMAIL_SUCCESS':
    case 'ADMIN_POINTS_SEND_EMAIL_FAILURE':
      return { ...state, message: action.message as AdminMessage };
    default:
      return state;
  }
}
